import React from 'react';

const EditSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g id="Group 19267">
        <g id="Group">
          <path
            id="edit-user"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.25 0.205944C15.2571 0.204877 15.2642 0.203962 15.2714 0.203192C15.425 0.186021 15.5782 0.238995 15.6882 0.34739L20.0477 4.70655C20.1452 4.80296 20.2 4.93425 20.2 5.07126C20.2 5.20809 20.1452 5.33938 20.0477 5.43579L6.71256 18.7698C6.64422 18.8376 6.558 18.8849 6.46409 18.9061L0.822288 20.1883C0.769567 20.1997 0.71617 20.2027 0.663911 20.1977C0.716187 20.2027 0.769601 20.1998 0.82234 20.1883L6.46414 18.9062C6.55805 18.8849 6.64427 18.8377 6.71261 18.7699L20.0478 5.43579C20.1453 5.33938 20.2 5.20809 20.2 5.07126C20.2 4.93424 20.1453 4.80296 20.0478 4.70655L15.6882 0.347379C15.5782 0.238984 15.4251 0.18601 15.2714 0.203181C15.2642 0.203952 15.2571 0.204874 15.25 0.205944ZM1.48983 13.5405C1.39554 13.6356 1.33002 13.7553 1.30047 13.8855L0.0183236 19.5265C-0.0366682 19.7645 0.0339412 20.0141 0.205632 20.188C0.377282 20.3619 0.626125 20.4356 0.864846 20.3837L6.50835 19.1012C6.63866 19.0717 6.75897 19.0056 6.85402 18.9113L20.1889 5.57753C20.3241 5.44358 20.4 5.26128 20.4 5.07126C20.4 4.88109 20.3236 4.69831 20.1884 4.56434L15.8297 0.205948L15.8286 0.204915C15.6757 0.0542416 15.463 -0.0193443 15.2496 0.00437309C15.0901 0.0216134 14.941 0.0922128 14.8266 0.204841L14.8256 0.205919L1.48983 13.5405ZM15.3276 1.43721L15.3275 1.43719L13.4843 3.28024L17.1226 6.91015L17.1226 6.91012L13.4844 3.28023L15.3276 1.43721ZM17.1228 6.62778L13.7674 3.28007L15.3276 1.72001L18.6827 5.07484L17.1228 6.62778ZM12.7631 4.00145L12.7631 4.00143L2.71363 14.0499L2.71383 14.05L6.3519 17.6798L6.35222 17.6795L2.71383 14.05L12.7631 4.00145ZM7.71579 16.3171L16.4014 7.6394L16.4011 7.63918L7.71579 16.3171ZM12.7631 4.28425L2.99669 14.0497L6.35186 17.3972L16.1185 7.63934L12.7631 4.28425ZM1.39125 19.0104L2.28871 15.068L2.28866 15.068L1.39119 19.0104L1.39125 19.0104ZM1.65682 18.7448L2.40335 15.4654L4.9365 17.9984L1.65682 18.7448Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export default EditSVG;
